import { TimeGranularity } from '../../../../models/paymentSummary';

export function formatBucketLabel(d: Date, granularity: TimeGranularity): string {
    const locale =
        typeof navigator !== 'undefined' && navigator.language
            ? navigator.language
            : 'ru-RU';
    switch (granularity) {
        case TimeGranularity.Hour:
            return new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
            }).format(d);
        case TimeGranularity.Month:
            return new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: '2-digit',
            }).format(d);
        case TimeGranularity.Day:
        default:
            return new Intl.DateTimeFormat(locale, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(d);
    }
}

export function bucketKey(d: Date, granularity: TimeGranularity): string {
    switch (granularity) {
        case TimeGranularity.Hour:
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:00`;
        case TimeGranularity.Month:
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}`;
        case TimeGranularity.Year:
            return `${d.getFullYear()}`;
        case TimeGranularity.Day:
        default:
            return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
    }
}

export function keyToDate(key: string): Date {
    const parts = key.split(/[-\s:]/);
    const y = parseInt(parts[0], 10);
    const m = parts.length > 1 ? parseInt(parts[1], 10) - 1 : 0;
    const day = parts.length > 2 ? parseInt(parts[2], 10) : 1;
    const hour = parts.length > 3 ? parseInt(parts[3], 10) : 0;
    return new Date(y, m, day, hour, 0, 0, 0);
}

export function addBucketStep(d: Date, granularity: TimeGranularity): Date {
    switch (granularity) {
        case TimeGranularity.Hour: {
            const nd = new Date(d);
            nd.setHours(nd.getHours() + 1, 0, 0, 0);
            return nd;
        }
        case TimeGranularity.Month:
            return new Date(d.getFullYear(), d.getMonth() + 1, 1);
        case TimeGranularity.Year:
            return new Date(d.getFullYear() + 1, 0, 1);
        case TimeGranularity.Day:
        default:
            return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    }
}

export function startBucketDate(from: Date, granularity: TimeGranularity): Date {
    switch (granularity) {
        case TimeGranularity.Hour:
            return new Date(from.getFullYear(), from.getMonth(), from.getDate(), from.getHours(), 0, 0, 0);
        case TimeGranularity.Month:
            return new Date(from.getFullYear(), from.getMonth(), 1);
        case TimeGranularity.Year:
            return new Date(from.getFullYear(), 0, 1);
        case TimeGranularity.Day:
        default:
            return new Date(from.getFullYear(), from.getMonth(), from.getDate());
    }
}

export function enumerateBuckets(
    from: Date,
    to: Date,
    granularity: TimeGranularity,
): Array<{ key: string; date: Date }> {
    const start = startBucketDate(from, granularity);
    const endTime = to.getTime();
    const result: Array<{ key: string; date: Date }> = [];
    for (let d = start; d.getTime() <= endTime; d = addBucketStep(d, granularity)) {
        result.push({ key: bucketKey(d, granularity), date: keyToDate(bucketKey(d, granularity)) });
        if (result.length > 100000) {
            break;
        }
    }
    return result;
}
